import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Loading from '@components/Loading';
import SearchCustom from '@components/Input/SearchCustom';
import ButtonIssuance from '@components/Button/ButtonIssuance';
import {
  ItemWrapper,
  Line,
  ListWrapper,
  NodataWrapper,
  ScrollWrapperAgency,
  SideBarOperatorWrapper,
} from '@containers/OperatorSite/Operator/SideBarOperator/sideBarOperatorStyle';
import { CONST_AGENCY_SITE, CONST_CREATE_COMPANY } from 'constants/language';

import { CONST_LIST_OPERATOR } from '@pages/OperatorSite/Operators/ListOperator/constants';
import { IListCompany } from '../../pages/AgencySite/Companies/interface';

interface IItem {
  id: number;
  code: string;
  name: string;
  selected: IListCompany | null;
  onSelectItem: () => void;
}

const Item = ({ id, code, name, selected, onSelectItem }: IItem) => {
  return (
    <ItemWrapper isSelected={selected?.id === id} onClick={onSelectItem}>
      <div>{code}</div>
      <div>{name}</div>
    </ItemWrapper>
  );
};

interface ISideBarOperator {
  listCompany: IListCompany[];
  isLoading: boolean;
  selected: IListCompany | null;
  onSearch: (searchText: string) => void;
  setSelected: (company: IListCompany | null) => void;
  isPermissionCreate: boolean;
  value?: string;
  setValue?: React.Dispatch<React.SetStateAction<string>>;
}

const SideBarCompany = ({
  listCompany,
  isLoading,
  selected,
  onSearch,
  setSelected,
  isPermissionCreate,
  value,
  setValue,
}: ISideBarOperator) => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const paramSerach = query.get('name') ?? '';

  const toCreateOperator = () => {
    navigate('/company/create');
  };

  const onSelectItem = (company: IListCompany) => {
    setSelected(company);
    navigate({
      pathname: `/companies/${btoa(company.id.toString())}`,
      search: `?name=${paramSerach}`,
    });
  };

  return (
    <SideBarOperatorWrapper>
      <ListWrapper>
        <SearchCustom
          onSearch={onSearch}
          placeholder={CONST_AGENCY_SITE.ENTER_COMPANY_NAME_OR_COMPANY_CODE}
          value={value}
          setValue={setValue}
        />
        {listCompany?.length > 0 && (
          <ScrollWrapperAgency>
            {listCompany.map((element: IListCompany) => {
              return (
                <React.Fragment key={String(element.id)}>
                  <Item
                    id={element.id}
                    code={element.code}
                    name={element.name}
                    onSelectItem={() => onSelectItem(element)}
                    selected={selected}
                  />
                </React.Fragment>
              );
            })}
          </ScrollWrapperAgency>
        )}

        {isLoading && <Loading />}

        {listCompany?.length === 0 && !isLoading ? (
          <NodataWrapper>{CONST_LIST_OPERATOR.NO_DATA}</NodataWrapper>
        ) : (
          <div />
        )}
      </ListWrapper>

      {isPermissionCreate && (
        <div>
          <Line />
          <ButtonIssuance onClick={toCreateOperator} label={CONST_CREATE_COMPANY.CORPORATE} />
        </div>
      )}
    </SideBarOperatorWrapper>
  );
};

export default SideBarCompany;
